export default "__VITE_ASSET__BFY_LHeV__"